'use strict';

const { h } = require('phy');

const Header = require('../../shared/views/header');
const RedemptionProvider = require('../../redemption/views/redemption-provider-hoc');

const MainContent = require('./top-offers-main-content');
const SideBar = require('./top-offers-sidebar');
const Footer = require('../../../components/footer');

function getElements({ isTouch, couponsForList, routes, advertsForCarousel }) {
  const mainContentElement = MainContent({ couponsForList, routes });
  const sidebarElement = SideBar({ advertsForCarousel, routes, isTouch });

  if (isTouch) {
    return [h('.twelve.column', [mainContentElement, sidebarElement])];
  }

  return [
    h('.nine.column.push-three', mainContentElement),
    h('.three.column.pull-nine', sidebarElement),
  ];
}

function TopOffers({ payload, deps }) {
  const {
    seoMetaData: { h1Override },
    navigationMerchants,
    couponsForList,
    advertsForCarousel,
  } = payload;
  const { datetime, routes, isTouch } = deps;

  return h('article.wrapper-page', [
    h(RedemptionProvider, { routes }),
    h(Header, {
      routes,
      activePage: 'top-offers',
      merchants: navigationMerchants,
      titleText: h1Override,
      resourceKey: 'modules.top_offers.PageHeadingFormat',
      params: {
        0: datetime().format('MMMM YYYY'),
      },
    }),
    h(
      'section.page-container',
      h('.row', [
        ...getElements({
          isTouch,
          couponsForList,
          routes,
          advertsForCarousel,
        }),
        h('.twelve.column', Footer()),
      ])
    ),
  ]);
}

module.exports = TopOffers;
